import * as React from "react";
import { useTranslation } from "react-i18next";
import Row from "../Row/Row";

type Props = {
  field: string;
  categoryName: string;
  tarifName: string;
  children: React.ReactNode;
};

const SleepingCustomerRow = ({ field, categoryName, tarifName, children }: Props) => {
  const { t } = useTranslation(["sleepingCustomer"]);
  return (
    <Row label={t(`${field}.question`)} subQuestion={t(`${field}.subQuestion`, { categoryName, tarifName })}>
      {children}
    </Row>
  );
};

export default SleepingCustomerRow;
